import LoadingButton from '@mui/lab/LoadingButton';
import { Theme } from '@mui/material';
import { useTheme } from '@mui/material';
import { useFormik, useFormikContext } from 'formik';
import { useEffect, useState } from "react";

const MFSubmitButton = ({
  label = 'Submit',
  variant = 'contained',
  fullWidth = true,
  loadingEnable,
  disabled = false,
  ...props
}: {
  label: string;
  variant?: 'contained' | 'text' | 'outlined' | undefined;
  fullWidth?: boolean;
  loadingEnable?: boolean;
  disabled?: boolean;
}): JSX.Element => {
  const theme = useTheme()
  const formikContext = useFormikContext();
  // const formik = useFormik()
  const { isSubmitting: loading } = formikContext;

  const containedVariantStyle = {
    color: 'textDark.primary',
    backgroundColor: 'primary.500',
    padding: "10px",
    ...theme.typography.body_600
  }

  const outlinedVariantStyle = {
    color: 'text.secondary',
    backgroundColor: 'transparent',
    borderColor: 'text.secondary',
    borderWidth: '0.5px',
    borderStyle: 'solid',
    padding: "10px",
    "&:hover, &.Mui-focusVisible": { borderColor: 'text.secondary', backgroundColor: "background.default" },
    ...theme.typography.body_600
  }

  let currentStyle = {}

  if (variant === "contained") {
    currentStyle = containedVariantStyle
  } else if (variant === "outlined") {
    currentStyle = outlinedVariantStyle
  }

  return (
    <LoadingButton
      loadingPosition="start"
      type="submit"
      loading={loadingEnable}
      variant={variant}
      sx={(theme: Theme) => ({ ...currentStyle, ...theme.typography.body_600 })}
      fullWidth={fullWidth}
      disabled={disabled}
      {...props}>
      {label}
    </LoadingButton >
  );
  // return (
  //   <Button
  //     type="submit"
  //     fullWidth={fullWidth}
  //     variant={variant}
  //     sx={{ mt: 3, mb: 2, color: 'common.white', lineHeight: 1.5, fontSize: 14 }}
  //     disabled={disabled}
  //     {...props}>
  //     {l}
  //   </Button>
  // );
};
export default MFSubmitButton;
